var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500px" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-form",
            {
              staticClass: "collaborators__form-dialog",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.onSubmit($event)
                }
              }
            },
            [
              _c("v-card-title", { staticClass: "collaborators__form-title" }, [
                _c("span", [_vm._v("Nueva tarifa")])
              ]),
              _c(
                "v-card-text",
                { staticClass: "pt-0" },
                [
                  _c(
                    "v-container",
                    { staticStyle: { width: "378px" } },
                    [
                      _c("v-select", {
                        attrs: { items: _vm.platforms, label: "Plataforma" },
                        on: { change: _vm.selectPlatform },
                        model: {
                          value: _vm.platform,
                          callback: function($$v) {
                            _vm.platform = $$v
                          },
                          expression: "platform"
                        }
                      }),
                      _c(
                        "div",
                        { staticClass: "item-row" },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.channels,
                              label: "Canal",
                              disabled: _vm.selectChannel,
                              "return-object": ""
                            },
                            model: {
                              value: _vm.channel,
                              callback: function($$v) {
                                _vm.channel = $$v
                              },
                              expression: "channel"
                            }
                          }),
                          _c(
                            "div",
                            { staticClass: "slide__item-switch style1" },
                            [
                              _c(
                                "div",
                                { staticClass: "slide__switch" },
                                [
                                  _c("v-switch", {
                                    model: {
                                      value: _vm.switchChannel,
                                      callback: function($$v) {
                                        _vm.switchChannel = $$v
                                      },
                                      expression: "switchChannel"
                                    }
                                  }),
                                  _c("p", [_vm._v("Aplica")])
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "item-row" },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.subproducts,
                              label: "Subproducto"
                            },
                            on: { change: _vm.selectCoin },
                            model: {
                              value: _vm.subproduct,
                              callback: function($$v) {
                                _vm.subproduct = $$v
                              },
                              expression: "subproduct"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "item-row" },
                        [
                          _c("v-select", {
                            attrs: { items: _vm.currencies, label: "Moneda" },
                            on: { change: _vm.changeCoin },
                            model: {
                              value: _vm.currency,
                              callback: function($$v) {
                                _vm.currency = $$v
                              },
                              expression: "currency"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "item-row" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              type: "text",
                              label: "Afiliacion",
                              disabled: _vm.selectAffiliation
                            },
                            model: {
                              value: _vm.affiliation,
                              callback: function($$v) {
                                _vm.affiliation =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "affiliation"
                            }
                          }),
                          _c(
                            "div",
                            { staticClass: "slide__item-switch style1" },
                            [
                              _c(
                                "div",
                                { staticClass: "slide__switch" },
                                [
                                  _c("v-switch", {
                                    model: {
                                      value: _vm.switchAffiliation,
                                      callback: function($$v) {
                                        _vm.switchAffiliation = $$v
                                      },
                                      expression: "switchAffiliation"
                                    }
                                  }),
                                  _c("p", [_vm._v("Aplica")])
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "item-row" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              type: "text",
                              label: "Comentario afiliacion",
                              disabled: _vm.selectAffiliationComment
                            },
                            model: {
                              value: _vm.affiliationComment,
                              callback: function($$v) {
                                _vm.affiliationComment =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "affiliationComment"
                            }
                          }),
                          _c(
                            "div",
                            { staticClass: "slide__item-switch style1" },
                            [
                              _c(
                                "div",
                                { staticClass: "slide__switch" },
                                [
                                  _c("v-switch", {
                                    model: {
                                      value: _vm.switchAffiliationComment,
                                      callback: function($$v) {
                                        _vm.switchAffiliationComment = $$v
                                      },
                                      expression: "switchAffiliationComment"
                                    }
                                  }),
                                  _c("p", [_vm._v("Aplica")])
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "item-row" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              type: "text",
                              label: "Costo de equipo",
                              disabled: _vm.selectEquipmentCost
                            },
                            model: {
                              value: _vm.equipmentCost,
                              callback: function($$v) {
                                _vm.equipmentCost =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "equipmentCost"
                            }
                          }),
                          _c(
                            "div",
                            { staticClass: "slide__item-switch style1" },
                            [
                              _c(
                                "div",
                                { staticClass: "slide__switch" },
                                [
                                  _c("v-switch", {
                                    model: {
                                      value: _vm.switchEquipmentCost,
                                      callback: function($$v) {
                                        _vm.switchEquipmentCost = $$v
                                      },
                                      expression: "switchEquipmentCost"
                                    }
                                  }),
                                  _c("p", [_vm._v("Aplica")])
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "item-row" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              type: "text",
                              label: "Comentario costo de equipo",
                              disabled: _vm.selectEquipmentCostComment
                            },
                            model: {
                              value: _vm.equipmentCostComment,
                              callback: function($$v) {
                                _vm.equipmentCostComment =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "equipmentCostComment"
                            }
                          }),
                          _c(
                            "div",
                            { staticClass: "slide__item-switch style1" },
                            [
                              _c(
                                "div",
                                { staticClass: "slide__switch" },
                                [
                                  _c("v-switch", {
                                    model: {
                                      value: _vm.switchEquipmentCostComment,
                                      callback: function($$v) {
                                        _vm.switchEquipmentCostComment = $$v
                                      },
                                      expression: "switchEquipmentCostComment"
                                    }
                                  }),
                                  _c("p", [_vm._v("Aplica")])
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "item-row" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              type: "text",
                              label: _vm.isSolesMantenimiento,
                              disabled: _vm.selectMaintenance
                            },
                            model: {
                              value: _vm.maintenance,
                              callback: function($$v) {
                                _vm.maintenance =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "maintenance"
                            }
                          }),
                          _c(
                            "div",
                            { staticClass: "slide__item-switch style1" },
                            [
                              _c(
                                "div",
                                { staticClass: "slide__switch" },
                                [
                                  _c("v-switch", {
                                    model: {
                                      value: _vm.switchMaintenance,
                                      callback: function($$v) {
                                        _vm.switchMaintenance = $$v
                                      },
                                      expression: "switchMaintenance"
                                    }
                                  }),
                                  _c("p", [_vm._v("Aplica")])
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm.showSwitchDollar
                        ? _c(
                            "div",
                            { staticClass: "item-row" },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "text",
                                  label: "Mantenimiento Dólares",
                                  disabled: _vm.selectMaintenanceDollar
                                },
                                model: {
                                  value: _vm.maintenanceDollar,
                                  callback: function($$v) {
                                    _vm.maintenanceDollar =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "maintenanceDollar"
                                }
                              }),
                              _c(
                                "div",
                                { staticClass: "slide__item-switch style1" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "slide__switch" },
                                    [
                                      _c("v-switch", {
                                        model: {
                                          value: _vm.switchMaintenanceDollar,
                                          callback: function($$v) {
                                            _vm.switchMaintenanceDollar = $$v
                                          },
                                          expression: "switchMaintenanceDollar"
                                        }
                                      }),
                                      _c("p", [_vm._v("Aplica")])
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "item-row" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              type: "text",
                              label: "Comentario mantenimiento",
                              disabled: _vm.selectMaintenanceComment
                            },
                            model: {
                              value: _vm.maintenanceComment,
                              callback: function($$v) {
                                _vm.maintenanceComment =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "maintenanceComment"
                            }
                          }),
                          _c(
                            "div",
                            { staticClass: "slide__item-switch style1" },
                            [
                              _c(
                                "div",
                                { staticClass: "slide__switch" },
                                [
                                  _c("v-switch", {
                                    model: {
                                      value: _vm.switchMaintenanceComment,
                                      callback: function($$v) {
                                        _vm.switchMaintenanceComment = $$v
                                      },
                                      expression: "switchMaintenanceComment"
                                    }
                                  }),
                                  _c("p", [_vm._v("Aplica")])
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "item-row" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              type: "text",
                              label: "Uso de plataforma CE",
                              disabled: _vm.selectPlatformUsageCE
                            },
                            model: {
                              value: _vm.platformUsageCE,
                              callback: function($$v) {
                                _vm.platformUsageCE =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "platformUsageCE"
                            }
                          }),
                          _c(
                            "div",
                            { staticClass: "slide__item-switch style1" },
                            [
                              _c(
                                "div",
                                { staticClass: "slide__switch" },
                                [
                                  _c("v-switch", {
                                    model: {
                                      value: _vm.switchPlatformUsageCE,
                                      callback: function($$v) {
                                        _vm.switchPlatformUsageCE = $$v
                                      },
                                      expression: "switchPlatformUsageCE"
                                    }
                                  }),
                                  _c("p", [_vm._v("Aplica")])
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "item-row" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              type: "text",
                              label: "Comentario uso de plataforma CE",
                              disabled: _vm.selectPlatformUsageCEComment
                            },
                            model: {
                              value: _vm.platformUsageCEComment,
                              callback: function($$v) {
                                _vm.platformUsageCEComment =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "platformUsageCEComment"
                            }
                          }),
                          _c(
                            "div",
                            { staticClass: "slide__item-switch style1" },
                            [
                              _c(
                                "div",
                                { staticClass: "slide__switch" },
                                [
                                  _c("v-switch", {
                                    model: {
                                      value: _vm.switchPlatformUsageCEComment,
                                      callback: function($$v) {
                                        _vm.switchPlatformUsageCEComment = $$v
                                      },
                                      expression: "switchPlatformUsageCEComment"
                                    }
                                  }),
                                  _c("p", [_vm._v("Aplica")])
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "item-row" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              type: "text",
                              label: "Renovación",
                              disabled: _vm.selectRenewal
                            },
                            model: {
                              value: _vm.renewal,
                              callback: function($$v) {
                                _vm.renewal =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "renewal"
                            }
                          }),
                          _c(
                            "div",
                            { staticClass: "slide__item-switch style1" },
                            [
                              _c(
                                "div",
                                { staticClass: "slide__switch" },
                                [
                                  _c("v-switch", {
                                    model: {
                                      value: _vm.switchRenewal,
                                      callback: function($$v) {
                                        _vm.switchRenewal = $$v
                                      },
                                      expression: "switchRenewal"
                                    }
                                  }),
                                  _c("p", [_vm._v("Aplica")])
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "item-row" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              type: "text",
                              label: "Comentario renovación",
                              disabled: _vm.selectRenewalComment
                            },
                            model: {
                              value: _vm.renewalComment,
                              callback: function($$v) {
                                _vm.renewalComment =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "renewalComment"
                            }
                          }),
                          _c(
                            "div",
                            { staticClass: "slide__item-switch style1" },
                            [
                              _c(
                                "div",
                                { staticClass: "slide__switch" },
                                [
                                  _c("v-switch", {
                                    model: {
                                      value: _vm.switchRenewalComment,
                                      callback: function($$v) {
                                        _vm.switchRenewalComment = $$v
                                      },
                                      expression: "switchRenewalComment"
                                    }
                                  }),
                                  _c("p", [_vm._v("Aplica")])
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "collaborators__buttons-container" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary-button text black uppercase",
                      on: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary-button blue w110",
                      attrs: { disabled: _vm.disabled, type: "submit" }
                    },
                    [_vm._v("Guardar")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("loader", {
            ref: "loaderModal",
            attrs: { text: "Procesando información" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b9a14be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b9a14be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tariffs/new-tariff-modal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2b9a14be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tariffs/new-tariff-modal.vue
// module chunks = 13